import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';
import {AuthService} from '../../../services/auth.service';


@Injectable()
export class EnsureHttpsInterceptor implements HttpInterceptor {
    constructor(
        private auth: AuthService,
    ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // clone request and replace 'http://' with 'https://' at the same time
        // noinspection HttpUrlsUsage
        const secureReq = req.clone({
            url: req.url.replace('http://', 'https://')
                .replace('schedulebaseURL/', this.auth.apiHelper.scheduleAPIRUL)
                .replace('baseURL/', this.auth.acdBaseURL)
                .replace('apiBaseURL/', this.auth.apiBaseURL)
                .replace('licenseURL/', this.auth.licenseURL)
                .replace('awsURL/', this.auth.awsURL)
                .replace('utilityURL/', this.auth.utilityURL)
                .replace('skydataURL/', this.auth.skyDataURL)
        });

        // send the cloned, "secure" request to the next handler.
        // console.log('ensure:' + secureReq);
        return next.handle(secureReq);
    }
}
